import React, { useState } from 'react';
import Bounce from 'react-reveal/Bounce';
import TextField from '../Form/TextField';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import swal from 'sweetalert';
import { createReport } from '../../Admin/services/reportsService';

const ContactForm = () => {
  const [formInput, setFormInput] = useState({
    fullName: '',
    email: '',
    message: '',
  });

  const [errors, setErrors] = useState({});
  const [captchaToken, setCaptchaToken] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormInput(prev => ({
      ...prev,
      [name]: value,
    }));

    setErrors(prev => ({
      ...prev,
      [name]: '',
    }));
  };

  const handleCaptchaVerify = (token) => {
    setCaptchaToken(token);
    setErrors(prev => ({
      ...prev,
      captcha: '',
    }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formInput.fullName.trim()) newErrors.fullName = "Le nom complet est requis.";
    if (!formInput.email.trim()) newErrors.email = "L'email est requis.";
    if (!formInput.message.trim()) newErrors.message = "Le message est requis.";
    if (!captchaToken) newErrors.captcha = "Veuillez vérifier que vous êtes un humain.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      await createReport({
        name: formInput.fullName,
        email: formInput.email,
        message: formInput.message,
      });

      swal(
        'Message envoyé',
        "Votre rapport a été envoyé à l'administrateur.\n\nVous pouvez également contacter l'équipe support via les informations en bas de page, ou attendre une réponse dans un délai de 1 à 24h selon la charge de l’équipe.",
        'success'
      );

      setFormInput({
        fullName: '',
        email: '',
        message: '',
      });
      setCaptchaToken('');
    } catch (error) {
      swal('Erreur', 'Une erreur est survenue lors de l’envoi du message.', 'error');
    }
  };

  const Inputs = [
    { id: 1, type: "text", placeholder: "Nom complet", name: "fullName", value: formInput.fullName },
    { id: 2, type: "email", placeholder: "Email", name: "email", value: formInput.email },
  ];

  return (
    <form className="p-6 flex flex-col justify-center w-full lg:w-2/4 mx-auto" onSubmit={handleSubmit}>
      <div className="flex flex-col space-y-6">
        <Bounce left>
          {Inputs.map(input => (
            <div key={input.id} className="flex flex-col">
              <TextField
                type={input.type}
                placeholder={input.placeholder}
                name={input.name}
                value={input.value}
                onChange={handleChange}
              />
              {errors[input.name] && (
                <p className="text-red-500 text-sm mt-1">{errors[input.name]}</p>
              )}
            </div>
          ))}
        </Bounce>
      </div>

      <Bounce left>
        <div className="mt-6 flex flex-col">
          <textarea
            name="message"
            placeholder="Votre message"
            value={formInput.message}
            onChange={handleChange}
            className="w-full px-4 py-3 h-36 rounded-lg ring-paragaia focus:ring-4 focus:outline-none transition duration-300 border border-gray-300 resize-none"
          />
          {errors.message && (
            <p className="text-red-500 text-sm mt-1">{errors.message}</p>
          )}
        </div>

        <div className="mt-6">
          <HCaptcha
            sitekey="08fe0ab4-555e-4174-895e-7e2a7f8c8384"
            onVerify={handleCaptchaVerify}
          />
          {errors.captcha && (
            <p className="text-red-500 text-sm mt-1">{errors.captcha}</p>
          )}
        </div>

        <button
          type="submit"
          className="bg-paragaia text-white px-6 py-3 w-36 mt-6 rounded-lg hover:bg-paragaiaLight transition poppins"
        >
          Envoyer
        </button>
      </Bounce>
    </form>
  );
};

export default ContactForm;
